var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/lorem/index.js
// module id = 830
// module chunks = 0